var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { T } from "../admin.theme";
// Базовый контейнер-карточка: surface + border + скругление.
export var Panel = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n"], ["\n  background: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n"])), T.surface, T.border, T.radius);
var templateObject_1;
